import {useLocation, useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';

const AdvertisementTypeBS = ({
  open,
  setIsOpen,
  hasStore,
}: AdvertisementTypeBSPRops) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <BottomSheet
      onDismiss={() => setIsOpen(false)}
      open={open}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="flex flex-col gap-4 p-6 text-sm">
        <div
          className="text-gray-900 no-underline"
          onClick={() => navigate('/my-ads')}
        >
          آگهی‌های شخصی
        </div>
        <div
          className={`text-gray-900 no-underline ${
            !hasStore && 'opacity-40 pointer-events-none'
          }`}
          onClick={() =>
            navigate('/my-store-advertisement', {state: location.pathname})
          }
        >
          آگهی‌های فروشگاهی
        </div>
      </div>
    </BottomSheet>
  );
};

export default AdvertisementTypeBS;
